import DocumentResourceModel from '../../generated/types/model/resource/DocumentResourceModel';

export default class DocumentResourceViewModel extends DocumentResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
